import React from 'react'

function Signup() {
    return (
        <>
            <div className="container-fluid custom-page">
                <div className="row bg-white">
                    {/* <!-- The image half --> */}
                    <div className="col-md-6 col-lg-6 col-xl-7 d-none d-md-flex bg-primary-transparent-3">
                        <div className="row w-100 mx-auto text-center">
                            <div className="col-md-12 col-lg-12 col-xl-12 my-auto mx-auto w-100">
                                <img src="assets/images/media/pngs/5.png"
                                    className="my-auto ht-xl-80p wd-md-100p wd-xl-80p mx-auto" alt="logo" />
                            </div>
                        </div>
                    </div>
                    {/* <!-- The content half --> */}
                    <div className="col-md-6 col-lg-6 col-xl-5 bg-white py-4">
                        <div className="login d-flex align-items-center py-2">
                            {/* <!-- Demo content--> */}
                            <div className="container p-0">
                                <div className="row">
                                    <div className="col-md-10 col-lg-10 col-xl-9 mx-auto">
                                        <div className="card-sigin">
                                            <div className="mb-5 d-flex">
                                                <a href="/" className="header-logo"><img src="assets/images/brand-logos/desktop-logo.png"
                                                    className="desktop-logo ht-40" alt="logo" />
                                                    <img src="assets/images/brand-logos/desktop-white.png"
                                                        className="desktop-white ht-40" alt="logo" />
                                                </a>
                                            </div>
                                            <div className="card-sigin">
                                                <div className="main-signup-header">
                                                    <h3>Get Started</h3>
                                                    <h6 className="fw-medium mb-4 fs-17">It's free to signup and only takes a minute.</h6>
                                                    <form>
                                                        <div className="form-group mb-3">
                                                            <label className="form-label">First Name and last Name</label> <input className="form-control"
                                                                placeholder="Enter your first Name and last Name" type="text" />
                                                        </div>
                                                        <div className="form-group mb-3">
                                                            <label className="form-label">Email</label> <input className="form-control"
                                                                placeholder="Enter your email" type="text" />
                                                        </div>
                                                        <div className="form-group mb-3">
                                                            <label className="form-label">Password</label> <input className="form-control"
                                                                placeholder="Enter your password" type="password" />
                                                        </div>
                                                        <a href="/" className="btn btn-primary btn-block w-100">Create Account</a>
                                                        <div className="row mt-3">
                                                            <div className="col-sm-6">
                                                                <button className="btn btn-block w-100 btn-facebook"><i
                                                                    className="fab fa-facebook-f me-2"></i> Signup with
                                                                    Facebook</button>
                                                            </div>
                                                            <div className="col-sm-6 mt-2 mt-sm-0">
                                                                <button className="btn btn-info btn-block w-100"><i
                                                                    className="ri-twitter-x-fill me-2"></i> Signup with
                                                                    Twitter</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                    <div className="main-signin-footer mt-5">
                                                        <p>Already have an account? <a href="/Signin">Sign In</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- End --> */}
                        </div>
                    </div>
                    {/* <!-- End --> */}
                </div>
            </div>
        </>
    )
}

export default Signup